import { FC, ReactNode } from "react"

export const SimpleDashboardContent: FC<{ children: ReactNode }> = ({ children }) => {
  return <div className="p-4 md:p-16 mx-auto">
    {children}
  </div>
}

export const CenteredDashboardContent: FC<{ children: ReactNode }> = ({ children }) => {
  return <div className="max-w-screen-2xl p-4 md:p-16 mx-auto">
    {children}
  </div>
}
